import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';

const ENDPOINT = import.meta.env.DEV
  ? 'http://localhost:8080'
  : 'https://property-tax-api.yourwayhome.com';

export default function useGetClients() {
  const { isAuthenticated } = useAuth0();
  const token = window.localStorage.getItem('_token');

  return useQuery({
    queryKey: ['CLIENTS'],
    queryFn: async () => {
      const response = await fetch(`${ENDPOINT}/api/v1/clients`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch clients: ${response.statusText}`);
      }

      return (await response.json()).data.data;
    },
    enabled: isAuthenticated && !!token,
  });
}
